import React from "react";
import CardEMROPDSummary from "./CardEMROPDSummary";
import CardDischargeSummaryView from "./CardDischargeSummaryView";
import CardLayout from "../common/CardLayout";
import { Dimmer, Loader } from "semantic-ui-react";
import { useIntl } from "react-intl";
import CheckupReportSerializer from "issara-sdk/types/CheckupReportSerializer_core";

// Props
type CardEMRSummaryProps = {
  // OPD
  emrSummaryData?: Record<string, any>,
  patientPanelData?: Record<string, any>,
  getEMRSummaryData?: (e: any) => any,
  onPrintEMRSummary?: (e: any) => any,
  onPrintDischargeSummary: (e: any) => any,
  onPrintMedicalReport: (e: any) => void,
  onGetCheckupReportList: (e: any) => void,
  languageUX?: any;

  // Common
  closeable?: boolean,
  toggleable?: boolean,
  hideHeaderIcon?: boolean,
  isLoading?: boolean,

  masterData?: Record<string, any>,
  masterOptions?: any,

  // config
  isDisabledSentMobile?: boolean;
};

const CardEMRSummary = (props:CardEMRSummaryProps) => {
  if (
    props.emrSummaryData &&
    props.emrSummaryData?.status &&
    props.emrSummaryData?.status === "NODISCHARGESUMMARY"
  ) {
    return (
      <CardLayout
        titleText="Discharge Summary -"
        closeable={false}
        toggleable={false}
        hideHeaderIcon={true}
      >
        <Dimmer active={props.isLoading} inverted>
          <Loader />
        </Dimmer>
        Encounter นี้ไม่สามารถดูข้อมูล Discharge Summary ได้
      </CardLayout>
    );
  }

  return (
    <>
      {props.emrSummaryData && props.emrSummaryData.hasOwnProperty("dischargeSummary") ? (
        <CardDischargeSummaryView
          closeable={false}
          toggleable={false}
          hideHeaderIcon={true}
          defaultBackground={false}
          showBtnPrint={true}
          encounterType={"IPD"}
          dischargeSummaryData={props.emrSummaryData}
          masterData={props.masterData}
          dischargeSummaryLoading={props.isLoading}
          onPrintDischargeSummary={props.onPrintDischargeSummary}
          languageUX={props.languageUX}
        />
      ) : (
        <CardEMROPDSummary
          isDisabledSentMobile={props.isDisabledSentMobile}
          emrSummaryData={props.emrSummaryData}
          patientPanelData={props.patientPanelData}
          getEMRSummaryData={props.getEMRSummaryData}
          onPrintEMRSummary={props.onPrintEMRSummary}
          onPrintMedicalReport={props.onPrintMedicalReport}
          onGetCheckupReportList={props.onGetCheckupReportList}
          isLoading={props.isLoading}
          closeable={false}
          toggleable={false}
          masterOptions={props.masterOptions}
          languageUX={props.languageUX}
        />
      )}
    </>
  );
};

export default CardEMRSummary;
